import useAuth from "../../hooks/useAuth";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getDefaultAuthorizedRoute } from "../../utils/common";
import { memo } from "react";

export function AgencyGuard({ children }) {
  const { isAuthenticated, user, accessType } = useAuth();

  if (!isAuthenticated && user === null) {
    return <Navigate to="/" />;
  }

  if (user && accessType === 1) {
    return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
  }

  if (user && (accessType === 2 || accessType === 4)) {
    return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
  }

  if (user && accessType === 5) {
    return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
  }

  return <>{children}</>;
}

AgencyGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(AgencyGuard);
